@if (range) {
  <div class="flex items-center flex-wrap" style="gap: 2rem">
    <mat-form-field appearance="outline">
      <mat-label>Date Range</mat-label>
      <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
        <input matStartDate formControlName="startDate" placeholder="Start date" (dateChange)="enableFilterButton()">
        <input matEndDate formControlName="endDate" placeholder="End date" (dateChange)="enableFilterButton()">
      </mat-date-range-input>
      <mat-hint>7 days range max</mat-hint>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker maxRange=6></mat-date-range-picker>

      <mat-error *ngIf="range.controls.startDate.hasError('matStartDateInvalid')">Invalid start date</mat-error>
      <mat-error *ngIf="range.controls.endDate.hasError('matEndDateInvalid')">Invalid end date</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Timezone</mat-label>
      <mat-select [(ngModel)]="selectedTimezone" (selectionChange)="onTimezoneSelected()" panelClass="timezone-panel">
        <mat-option class="timezone-search-panel" (click)="$event.stopPropagation()"
                    (mousedown)="$event.stopPropagation()">
          <input type="text"
                 placeholder="Search Timezone..."
                 [(ngModel)]="timezoneSearch"
                 (keyup)="filterTimezones()"
                 class="timezone-search"
                 (click)="$event.stopPropagation()"
                 (mousedown)="$event.stopPropagation()"
          />
        </mat-option>
        <mat-option *ngFor="let timezone of filteredTimezones" [value]="timezone"
                    [ngClass]="{'timezone-utc': timezone === 'UTC'}">
          {{ timezone }}
        </mat-option>
      </mat-select>
    </mat-form-field>


    <button mat-fab color="primary" aria-label="Filter" matTooltip="Apply filter" (click)="applyFilter()"
            [disabled]="!filterEnabled" style="margin-top: -21px">
      <mat-icon>filter_alt</mat-icon>
    </button>
  </div>
}

<div style="margin-top: 2rem; width: 100%">
  <mat-form-field appearance="outline" style="width: 100%">
    <mat-label>Enter developer, account, site, program, battery system or activity type / status.</mat-label>
    <mat-chip-grid #chipGrid aria-label="Selected Projects">
      @for (project of selectedProjects; track $index) {
        <mat-chip-row (removed)="removeProject(project)">
          {{ project.name }}
          <button matChipRemove [attr.aria-label]="'remove ' + project.name">
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
      }
    </mat-chip-grid>

    <input type="text"
           placeholder="Search..."
           #projectInput
           [(ngModel)]="currentProject"
           [matAutocomplete]="auto"
           [matChipInputFor]="chipGrid"
           [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
           (matChipInputTokenEnd)="addProject($event)">

    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectProject($event); projectInput.value = ''">
      <ng-container *ngFor="let group of categories">
        <mat-optgroup *ngIf="group.children.length" [label]="group.title">
          <mat-option *ngFor="let item of filteredChildren(group.id)()" [value]="item">
            {{ item.name }}
          </mat-option>
        </mat-optgroup>
      </ng-container>
    </mat-autocomplete>
  </mat-form-field>
</div>
